module.exports = __webpack_public_path__ + "static/media/2.2f6a8ae4.svg";